module.exports = __webpack_public_path__ + "img/bill-bgBottom1.3fb82283.png";